import Plyr from 'plyr';

document.addEventListener('DOMContentLoaded', () => {
  const players = Array.from(document.querySelectorAll('audio')).map(audio => {
    const player = new Plyr(audio, {});
    return player;
  });
  
  // Expose player so it can be used from the console
  if (players.length > 0) {
    window.player = players[0];
  }
});